import { SelfInvoiceActionTypes } from "models/actionTypes/selfInvoiceActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const selfInvoiceSent = (invoiceId: string): SelfInvoiceActionTypes => {
  return {
    type: ReduxConstants.SelfInvoiceActions.SELFINVOICE_SENT,
    payload: invoiceId,
  };
};

export const selfInvoiceDiscarded = (invoiceId: string): SelfInvoiceActionTypes => {
  return {
    type: ReduxConstants.SelfInvoiceActions.SELFINVOICE_DISCARDED,
    payload: invoiceId,
  };
};

export const selfInvoiceSnoozed = (invoiceId: string): SelfInvoiceActionTypes => {
  return {
    type: ReduxConstants.SelfInvoiceActions.SELFINVOICE_SNOOZED,
    payload: invoiceId,
  };
};

export const selfInvoiceSaved = (selfInvoice: WintSuperkollAPIModel.SelfInvoice): SelfInvoiceActionTypes => {
  return {
    type: ReduxConstants.SelfInvoiceActions.SELFINVOICE_SAVED,
    payload: selfInvoice,
  };
};
